import { IEducationReview } from '@sapientpro/sapientpro-data-models';
import classnames from 'classnames';
import Img from '../../../components/Img';
import styles from './EducationReview.module.scss';

type ReviewsTextSlideProps = {
  review: IEducationReview,
  className?: string,
};
const EducationReview = ({ review, className }: ReviewsTextSlideProps) => (
  <div className={classnames(styles.slide, 'container', className)}>
    <div className={styles.slide__content}>
      <div className={styles.author}>
        <div className={styles.author__avatar}>
          <Img
            src={review.avatar.url}
            alt={review.avatar.alternativeText || review.name}
            withPreloader
          />
        </div>
        <div className={styles.author__info}>
          <p className={styles.author__name}>{review.name}</p>
          <p className={styles.author__description}>{review.position}</p>
        </div>
      </div>
      <p className={classnames(styles.text, 'bodyText')}>{review.feedback}</p>
    </div>
  </div>
);

export default EducationReview;
